'use client'

/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable react/no-unstable-nested-components */

import React, { useState, useEffect } from 'react'
import dynamic from 'next/dynamic'
import { segmentEventCommonPropFunc } from '@utils/segmentProperties'
import Shimmer from '@components/Shimmer/Shimmer'

const TravelSeoDesktopWidget = dynamic(() => import('./TravelSeoDesktopWidget'), {
  ssr: false,
  loading: () => <Shimmer />,
})

const RenderWidgetMobile = dynamic(() => import('../renderWidgetMobile'), {
  ssr: false,
})

const TravelMainSeoWidget = ({
  isBottomFloater,
  segmentEventCommonProperties,
  isMobileDevice,
}: {
  isBottomFloater?: boolean
  segmentEventCommonProperties?: any
  isMobileDevice?: any
}) => {
  const [properties, setProperties] = useState<any>(null)
  const commonProps = { isBottomFloater, isMobileDevice, segmentEventCommonProperties }

  useEffect(() => {
    const fetchProperties = async () => {
      const props = await segmentEventCommonPropFunc(segmentEventCommonProperties)
      setProperties({ ...props, funnel: 'entry' })
    }

    fetchProperties()
  }, [])

  return (
    <>
      {isMobileDevice && !isBottomFloater && (
        <RenderWidgetMobile
          ctaText="Check prices"
          legalText="UID 5909 *T&Cs Apply"
          source="seo"
          eventName="tap_btn_CTA_widget"
          properties={properties}
        />
      )}

      {(!isMobileDevice || isBottomFloater) && (
        <TravelSeoDesktopWidget {...commonProps} eventName="tap_btn_CTA_widget" properties={properties} />
      )}
    </>
  )
}

export default TravelMainSeoWidget
